var map = {
	"./Podcast_Ep_1.mp3": "IZH9",
	"./Podcast_Ep_Aguilera.mp3": "vN3V",
	"./Podcast_Ep_Ajizu.mp3": "36BU",
	"./Podcast_Ep_Besoain.mp3": "qpTg",
	"./Podcast_Ep_Cani.mp3": "4FyO",
	"./Podcast_Ep_Claudio Merlet.mp3": "FTO8",
	"./Podcast_Ep_Gabriel_Morales.mp3": "vJLc",
	"./Podcast_Ep_Mika Martini.mp3": "XD/R",
	"./Podcast_Ep_Munoz.mp3": "1luU",
	"./Podcast_Ep_Seiten_Wall.mp3": "suQf"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uXvU";


//////////////////
// WEBPACK FOOTER
// ./src/assets/podcast ^\.\/.*\.mp3$
// module id = uXvU
// module chunks = 0